export const WIDGET_PAGESIZE = 5;
